import { render, staticRenderFns } from "./wxlogin.vue?vue&type=template&id=6b722ab7&scoped=true&"
import script from "./wxlogin.vue?vue&type=script&lang=js&"
export * from "./wxlogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b722ab7",
  null
  
)

export default component.exports